const formatter = new Intl.NumberFormat('pt-BR', {
  currency: 'BRL',
  currencyDisplay: 'symbol',
  currencySign: 'standard',
  style: 'currency',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
  minimumIntegerDigits: 1,
});
const formatterMonetaryValue = (value: number | string | null): string => {
  if (!value) return formatter.format(0);

  let num = typeof value === 'string' ? parseFloat(value) || 0 : value;

  const isNegative = num < 0;
  num = Math.abs(num);

  const formatted = formatter.format(num);

  if (!isNegative) return formatted;

  return formatted.replace('R$ ', 'R$ -');
};
export default formatterMonetaryValue;
